// Heuristic detection of markdown in pasted plain text. We only auto-convert
// pasted text when it looks like markdown, otherwise plain prose (which may
// contain the occasional `*` or `_`) would be mangled. Detection is
// intentionally conservative: it requires block-level or clearly paired inline
// markdown syntax rather than a single stray delimiter.
const MARKDOWN_PATTERNS = [
  /^#{1,6}\s+\S/m, // ATX headings: "# Title"
  /^\s*[-*+]\s+\S/m, // bullet list item
  /^\s*\d+\.\s+\S/m, // ordered list item
  /^\s*>\s+\S/m, // blockquote
  /^\s*```/m, // fenced code block
  /^\s*~~~/m, // fenced code block (tilde)
  /!\[[^\]]*\]\([^)]+\)/, // image
  /\[[^\]]+\]\([^)]+\)/, // link
  /^\s*\|.+\|\s*$/m, // table row
  /(\*\*|__)\S[\s\S]*?\1/, // bold
  /(^|\s)`[^`\n]+`/, // inline code
  /^\s*[-*_]{3,}\s*$/m, // thematic break / horizontal rule
  /(?:^|\s):[a-zA-Z0-9_+-]+:/, // emoji shortcode (`:joy:` / `:joy::rocket:`)
]

export function isLikelyMarkdown(text) {
  if (typeof text !== "string") return false

  const trimmed = text.trim()
  if (!trimmed) return false

  return MARKDOWN_PATTERNS.some((pattern) => pattern.test(trimmed))
}

export default isLikelyMarkdown
